import { HOTELS_AND_SIGHTSEEING, RESORT, SIGHTSEEING_TRANSFER_TYPES, TRANSFER_TYPES, copyOfObject } from '../constants';

/* eslint-disable import/prefer-default-export */
export const addDaysToDate = (inputDate, numberOfDays) => {
    // Parse the input date string
    const date = new Date(inputDate);

    // Add the specified number of days
    date.setDate(date.getDate() + numberOfDays);

    // Format the resulting date as "YYYY-MM-DD"
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    // Return the formatted date string
    return `${year}-${month}-${day}`;
};

export const getAreaAndNoOfNights = (data) => {
    let numberOfNights;
    let area;
    data.fields.forEach((field) => {
        if (field?.field?.key === 'number_of_nights_1') {
            numberOfNights = field?.field?.input_value?.value;
        }
        if (field?.field?.key === 'area') {
            area = field?.field.input_value?.value;
        }
    });
    return { numberOfNights, area };
};
export const sumNumberOfNights = (formData, upToIndex) =>
    formData?.slice(0, upToIndex + 1).reduce((sum, group) => {
        group.fields.forEach((field) => {
            if (field.field.key === 'number_of_nights_1') {
                sum += field.field.input_value ? field.field.input_value.value : 1;
            }
        });
        return sum;
    }, 0);

export const getSightseeingTransferTypeLabel = (value) => SIGHTSEEING_TRANSFER_TYPES.find((type) => type.value === value)?.label ?? null;

export const getTransferTypeLabel = (value) => TRANSFER_TYPES.find((type) => type.value === value)?.label ?? null;

export const deepEqual = (obj1, obj2) => {
    if (obj1 === obj2) return true;

    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
        return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    return keys1.every((key) => keys2.includes(key) && deepEqual(obj1[key], obj2[key]));
};

export const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    return arr1.every((item, index) => deepEqual(item, arr2[index]));
};

export const getIsPriceAvailableInHotelsAndSightSeeingForm = (formFieldGroups = [], hotelIndex) => {
    if (formFieldGroups && Array.isArray(formFieldGroups) && formFieldGroups.length > 0) {
        const hotelForms = formFieldGroups?.filter((field) => field?.key === HOTELS_AND_SIGHTSEEING || field?.key === RESORT);
        const hotelFields = hotelForms?.find((i) => i?.hotel_index === hotelIndex) || hotelForms[0] || {};
        const hotelFormField = hotelFields?.fields?.find((i) => i?.field.key === 'hotel_code');
        const inputValue = hotelFormField?.field?.input_value;
        const isPriceAvailable = inputValue?.price === null;
        return isPriceAvailable;
    }
    return false;
};
export const disableGetQuoteButton = (formStructures, tabValue, isHHiForm = false) => {
    if (isHHiForm) {
        const { prefilledFormStructure = {} } = formStructures[tabValue] || {};
        const copyOfFormStructure = copyOfObject(prefilledFormStructure || {});
        const { form_field_groups: formFieldGroups = [] } = copyOfFormStructure;
        const hotelForms = formFieldGroups?.filter((field) => field?.key === HOTELS_AND_SIGHTSEEING || field?.key === RESORT);
        return hotelForms?.some((hotelItem) => {
            if (hotelItem?.fields && Array.isArray(hotelItem?.fields)) {
                const hotelFormField = hotelItem?.fields?.find((i) => i?.field.key === 'hotel_code');
                if (!hotelFormField) return true;
                const inputValue = hotelFormField?.field?.input_value;
                const isPriceAvailable = inputValue?.price === null;
                return isPriceAvailable;
            }
            return true;
        });
    }
    return false;
};
